module.exports = [
    { id : 'ACTIVE', label: 'Active' },
    { id : 'INACTIVE', label: 'Inactive' },
    { id : 'REQUESTED', label: 'Requested' },
    { id : 'REFUSED', label: 'Refused' },
    { id : 'ASSIGNED', label: 'Assigned' },
    { id : 'NOT ASSIGNED', label: 'Not Assigned' }
];
